export default {
  salesOrders: [],
  salesOrder: undefined,
};
